import { isNfbCustomer } from 'scripts/helpers/_utils';
import { readCookie } from 'scripts/modules/_cookies';

let headerObserver;
let header;

const resizeMobileNavBody = () => {
	if ( header ) {
		const mobileNavItems = document.querySelectorAll(
			'#header__desktop-header .primary-sub-menu > .sub-menu'
		);
		let headerHeight = header.offsetHeight;

		const setDesktopHeight = () => {
			headerHeight = header.offsetHeight;

			mobileNavItems.forEach( ( item ) => {
				item.style.maxHeight = `${ window.innerHeight - headerHeight }px`;
			} );
		};

		setDesktopHeight();

		window.addEventListener( 'resize', () => {
			setDesktopHeight();
		} );

		window.addEventListener( 'scroll', () => {
			setDesktopHeight();
		} );
	}
};

const mobileNav = () => {
	const mobileHeader = document.querySelector( '.header__mobile-header' );
	if ( mobileHeader ) {
		const headerBody = mobileHeader.querySelector( '.header__body' );
		const headerScrollableContent = mobileHeader.querySelector( '.header__nav-menu' );
		const headerFirst = mobileHeader.querySelector( '.header__mobile-heading-first' );
		const headerFirstSecond = mobileHeader.querySelector( '.header__mobile-heading-first-second' );
		const headerSecond = mobileHeader.querySelector( '.header__mobile-heading-second' );

		/**
		 * Primary items click handle.
		 */
		const primaryNavItems = mobileHeader.querySelectorAll(
			'.primary-sub-menu.menu-item-has-children'
		);
		const primaryNavMenu = mobileHeader.querySelector( '.header__body-content' );

		if ( primaryNavItems ) {
			primaryNavItems.forEach( ( primaryItem ) => {
				primaryItem.addEventListener( 'click', () => {
					if ( headerScrollableContent?.scrollTo ) {
						headerScrollableContent.scrollTo( 0, 0 );
					}
					primaryItem.classList.add( 'active' );
					primaryNavMenu.classList.add( 'open' );
					headerBody.classList.add( 'open' );
					headerBody.classList.add( 'with-back' );

					headerFirst.innerText = primaryItem.querySelector( 'a' ).innerText;
					headerFirstSecond.innerText = primaryItem.querySelector( 'a' ).innerText;
				} );
			} );
		}

		/**
		 * Secondary items click handle.
		 */
		const secondaryNavItems = mobileHeader.querySelectorAll(
			'.secondary-sub-menu.menu-item-has-children'
		);

		if ( secondaryNavItems ) {
			secondaryNavItems.forEach( ( secondaryItem ) => {
				const link = secondaryItem.querySelector( 'a' );

				link.addEventListener( 'click', ( el ) => {
					el.preventDefault();

					if ( window.screen.width < 768 ) {
						headerScrollableContent?.scrollTo( 0, 0 );
						secondaryNavItems.forEach( ( item ) => {
							if ( secondaryItem !== item ) {
								item.classList.remove( 'active' );
							}
						} );
						secondaryItem.classList.add( 'active' );
						headerBody.classList.add( 'child-item-active' );

						headerSecond.innerText = secondaryItem?.querySelector( 'a' )?.innerText;
					}
				} );
			} );
		}

		/**
		 * Back button handle.
		 */
		const goBack = () => {
			if ( primaryNavItems && secondaryNavItems ) {
				if ( headerScrollableContent?.scrollTo ) {
					headerScrollableContent.scrollTo( 0, 0 );
				}

				if ( headerBody.classList.contains( 'child-item-active' ) ) {
					[ ...secondaryNavItems ].forEach( ( item ) => {
						item.classList.remove( 'active' );
					} );
					headerBody.classList.remove( 'child-item-active' );
				} else {
					[ ...primaryNavItems, ...secondaryNavItems ].forEach( ( item ) => {
						item.classList.remove( 'active' );
					} );
					primaryNavMenu.classList.remove( 'open' );
					headerBody.classList.remove( 'open' );
					headerBody.classList.remove( 'with-back' );
				}
			}
		};

		const backButtons = Array.from( mobileHeader.querySelectorAll( '.header__back' ) );
		if ( backButtons.length > 0 ) {
			backButtons.forEach( ( backButton ) => {
				backButton.addEventListener( 'click', ( el ) => {
					el.preventDefault();
					goBack();
				} );
			} );
		}

		/**
		 * Hamburger button handle.
		 */
		const menuClasses = {
			menuItemActive: 'header__nav-menu-item_active',
			menuItems: '#header__mobile-header .menu-item-has-children',
			mobileHandlerBodyActive: 'header__body_active',
			mobileHandlerClose: '#header__menu-handler-image_close',
			mobileHandlerImageActive: 'header__menu-handler-image_active',
			mobileHandlerOpen: '#header__menu-handler-image_open',
			mobileHeaderBody: '#header__body',
			displayNone: 'd-none',
		};

		// Main menu show/hide.
		const mobileHandlerOpen = document.querySelector( menuClasses.mobileHandlerOpen );
		const mobileHandlerClose = document.querySelector( menuClasses.mobileHandlerClose );
		const mobileHeaderBody = document.querySelector( menuClasses.mobileHeaderBody );

		if ( mobileHandlerOpen ) {
			mobileHandlerOpen.addEventListener( 'click', () => {
				mobileHeaderBody.classList.add( menuClasses.mobileHandlerBodyActive );
				mobileHeader.classList.add( 'open' );
			} );
		}

		if ( mobileHandlerClose ) {
			mobileHandlerClose.addEventListener( 'click', () => {
				mobileHeaderBody.classList.remove( menuClasses.mobileHandlerBodyActive );
				mobileHeader.classList.remove( 'open' );
				goBack();
				goBack(); // In case of mobile view where menu can be nested twice.
			} );
		}
	}
};

export const stickyHeader = ( desktopHeader, mobileHeader ) => {
	const { scrollY } = window;
	if ( location.pathname.startsWith( '/hub' ) ) {
		return;
	}

	if ( scrollY > 0 ) {
		desktopHeader.classList.add( 'sticky' );
		mobileHeader.classList.add( 'sticky' );
	} else {
		desktopHeader.classList.remove( 'sticky' );
		mobileHeader.classList.remove( 'sticky' );
	}
};

const reInitOnHeaderChange = () => {
	const observerConfig = { attributes: false, childList: true, subtree: true };

	const callback = ( mutationList ) => {
		for ( const mutation of mutationList ) {
			if ( mutation.type === 'childList' ) {
				const promoBanner = document.querySelector( '.banner-promo' );
				if (
					! isNfbCustomer() &&
					! readCookie( 'closed_promo_top_bar' ) &&
					promoBanner &&
					promoBanner.classList.contains( 'd-none' )
				) {
					promoBanner.classList.remove( 'd-none' );
					promoBanner.classList.add( 'd-block' );

					document.querySelector( 'header' )?.classList?.remove( 'without-promo-banner' );
				}

				initHeader();
			}
		}
	};

	headerObserver = new MutationObserver( callback );
	headerObserver.observe( header, observerConfig );
};

export const initHeader = () => {
	header = document.querySelector( '.header' );
	if ( typeof headerObserver?.disconnect === 'function' ) {
		headerObserver.disconnect();
	}
	mobileNav();
	resizeMobileNavBody();
	const desktopHeader = document.querySelector( '.header__desktop-header' );
	const mobileHeader = document.querySelector( '.header__mobile-header' );

	if ( header ) {
		if ( desktopHeader ) {
			let scrollWaiting;
			stickyHeader( desktopHeader, mobileHeader );

			window.addEventListener( 'scroll', () => {
				stickyHeader( desktopHeader, mobileHeader );

				if ( scrollWaiting ) {
					return;
				}
				scrollWaiting = true;

				stickyHeader( desktopHeader, mobileHeader );

				setTimeout( () => {
					scrollWaiting = false;
				}, 100 );
			} );

			desktopHeader.querySelectorAll( 'li>a[tabindex]' ).forEach( ( item ) => {
				item.addEventListener( 'mouseenter', () => {
					const focusedElement = desktopHeader.querySelector( ':focus' );
					if ( focusedElement && focusedElement !== item ) {
						focusedElement.blur();
					}
				} );
			} );
		}

		reInitOnHeaderChange();
	}
};
